import { render, staticRenderFns } from "./editar-empleados.vue?vue&type=template&id=6509d5a2&"
import script from "./editar-empleados.vue?vue&type=script&lang=js&"
export * from "./editar-empleados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports